export default {
  'areas.create.notification.success': 'Success',
  'areas.create.notification.successDescription': 'Area created.',
  'areas.update.notification.success': 'Success',
  'areas.update.notification.successDescription': 'Area updated.',
  'areas.remove.notification.success': 'Success',
  'areas.remove.notification.successDescription': 'Area removed.',
  'areas.general.form.description': 'Area Description',
  'areas.general.form.executionOrder': 'Execution Order',
  'areas.general.form.button.remove': 'Remove',
  'areas.general.form.button.save': 'Save',
  'areas.modal.remove.title': 'Remove Area',
  'areas.modal.remove.content': 'Do you want to remove the area',
  'areas.modal.remove.button.ok': 'Remove',
  'areas.modal.remove.message.success': 'Area successfully removed!',
  'areas.modal.remove.message.error': 'Unable to remove area!',
  'areas.page.button.newService': 'New Area',
  'areas.modal.create.title': 'Add Area',
  'areas.modal.edit.title': 'Update Area',
  'areas.modal.create.message.success': 'Area successfully added!',
  'areas.modal.edit.message.success': 'Area successfully updated!',
  'areas.modal.message.error': 'Unable to execute the action!',
  'areas.subareas': 'Sub-Areas',
  'areas.subareas.create': 'Create New Sub-Area',
  'areas.subareas.create.notification.success': 'Success',
  'areas.subareas.create.notification.successDescription': 'Sub-Area created.',
  'areas.subareas.update': 'Update Sub-Area',
  'areas.subareas.update.notification.success': 'Success',
  'areas.subareas.update.notification.successDescription': 'Sub-Area updated.',
  'areas.subareas.description': 'Sub-Area description',
  'areas.filter.company': 'Company',

  'areas.modal.report.title': 'Generate Report',
  'areas.modal.report.buttons.viewReport': 'View Report',
  'areas.modal.report.buttons.pdf': 'Generate PDF',
  'areas.modal.report.buttons.rtf': 'Generate RTF',
  'areas.modal.report.buttons.csv': 'Generate CSV',
  'areas.modal.report.form.description': 'Description',
  'groups.notification.generate.report.title': 'Report Generated Successfully',
  'groups.notification.generate.report.description':
    'Area Report Successfully Generated!',

  'areas.error.alreadyExists': 'This area already exists!',
  'areas.error.remove.bonds':
    'The action could not be completed due to a violation of the links for this record!',

  'areas.status.message.success': 'Area status changed successfully!',
};
